class CursorDots {
    constructor(className) {
        this.className = className;
        this.init();
    }

    init() {
        let el = document.querySelectorAll(`${this.className}`);
        for (let i = 0; i < el.length; i++) {
            el[i].addEventListener('mouseenter', (e) => {
                this.handlerHoverFunction(e)
            })

            el[i].addEventListener('mouseleave', (e) => {
                this.handlerUnHoverFunction(e)
            })
        }
    }

    handlerUnHoverFunction(e) {
        let targetElem = document.getElementById(e.target.dataset.id)
        targetElem.style.opacity = '0'
        let elem = document.getElementById('canvas')
        elem.parentNode.removeChild(elem);
    }

    handlerHoverFunction(e) {
        this.targetIdElement = e.target.dataset.id

        let clickElement = e.target;
        let targetElem = document.getElementById(this.targetIdElement)
        targetElem.style.opacity = '1'

        this.canvasSize = this.getCanvasSize(clickElement, targetElem)

        let canvas = this.createCanvas()
        clickElement.append(canvas)
    }

    createCanvas() {
        let canvas = document.createElement("canvas");
        canvas.setAttribute("id", "canvas");
        if (this.canvasSize.width < 20) {
            this.canvasSize.width = 20;
        }
        canvas.width = this.canvasSize.width < 0 ? (this.canvasSize.width * -1) + 6 : this.canvasSize.width + 6;
        canvas.height = this.canvasSize.height + 12;
        canvas.style.position = "absolute";
        canvas.style.top = `-${this.canvasSize.height + 5}px`;
        canvas.style.left = `3px`;
        canvas.style.border = `none`;

        let ctx = canvas.getContext('2d');

        let startPos = 2;
        let endPos = this.canvasSize.width < 0 ? this.canvasSize.width * -1 : this.canvasSize.width;
        ctx.moveTo(startPos, this.canvasSize.height + 8);
        if (this.canvasSize.width > 40) {
            ctx.lineTo((startPos + 40), this.canvasSize.height + 8)
            ctx.lineTo(endPos, 0);
        } else {
            ctx.lineTo(4, 0);
        }

        ctx.lineWidth = 2;
        ctx.strokeStyle = '#14B7E0'
        ctx.stroke();
        return canvas;
    }

    getCanvasSize(clickElement, targetElem) {
        let canvasSize = {
            height: 0,
            width: 0
        }

        let targetElemHeight = targetElem.offsetHeight
        let targetElemWidth = targetElem.offsetWidth


        let clickElementHeight = clickElement.offsetHeight
        let clickElementCoordinates = this.getCoords(clickElement);
        let targetElemCoordinates = this.getCoords(targetElem);
        let differenceBetweenTopElements = clickElementCoordinates.top - targetElemCoordinates.top
        let differenceBetweenLeftElements = clickElementCoordinates.left - targetElemCoordinates.left

        if (differenceBetweenTopElements > targetElemHeight) {
            canvasSize.height = differenceBetweenTopElements - targetElemHeight
        } else {
            canvasSize.height = differenceBetweenTopElements - clickElementHeight
        }

        if (differenceBetweenLeftElements < 0) {
            differenceBetweenLeftElements *= -1
            canvasSize.width = differenceBetweenLeftElements + (targetElemWidth / 2)
        } else {
            canvasSize.width = differenceBetweenLeftElements - (targetElemWidth / 2)
        }

        return canvasSize
    }

    getCoords(elem) { // кроме IE8-
        let box = elem.getBoundingClientRect();

        return {
            top: box.top + pageYOffset,
            left: box.left + pageXOffset
        };
    }
}

class VinForm {
    constructor(className, searchBlockId) {
        this.className = className;
        this.resultSearchBlockId = searchBlockId;
        this.init();
    }

    init() {
        let el = document.querySelectorAll(`${this.className}`);
        for (let i = 0; i < el.length; i++) {
            el[i].addEventListener('submit', (e) => {
                this.handlerSubmitFunction(e)
            })
        }
    }

    handlerSubmitFunction(e) {
        e.preventDefault();
        window.appClassVinForm = this;
        this.formData = e.currentTarget
        this.startLoading()

        grecaptcha.ready(() => {
            grecaptcha.execute(window.recaptchaSiteKeyCode, {action: '/decoder'}).then(function (token) {
                window.appClassVinForm.send(token)
            });
        });
    }

    send(token) {
        let vin = this.formData.elements['vin'].value;
        let data = { vin: vin, recaptcha_response: token };

        function successCallback(response) {
            let res = JSON.parse(response);
            if (res.errors && res.errors.vin) {
                this.addErrorsToForm(res.errors.vin[0])
            }
            if (res.location && res.data) {
                let searchBlock = document.getElementById(this.resultSearchBlockId)
                this.addHtmlToBlockInfo(res.data, res.location, searchBlock)
                searchBlock.scrollIntoView({behavior: 'smooth'})
            }
            this.stopLoading()
        }

        this.runAjax(window.decoderUrl, data, successCallback.bind(this))
    }

    addHtmlToBlockInfo(dataHtml, location, element) {
        element.innerHTML = `${dataHtml}`;
    }

    runAjax(loadUrl, data, successCallback) {

        $.ajax({
            type: 'POST',
            url: loadUrl,
            data: data,
            dataType: 'html',
            success: function (response) {
                successCallback(response);
            },
            error: function (message) { // if error occured
                console.log(message);
            }
        });

    }

    addErrorsToForm(message) {
        let er = $(this.formData.firstElementChild)
        er.find('.error-text').text(message);
        er.find('.search-vin__decoder-vin-input').addClass('errors');

        setTimeout(this.clearErrorsToForm.bind(this), 2500);
    }

    clearErrorsToForm() {
        $(this.formData.firstElementChild).find('.error-text').text('')
        $(this.formData.firstElementChild).find('.search-vin__decoder-vin-input').removeClass('errors')
    }

    startLoading() {
        $(this.formData.firstElementChild).find('.loader1212decoder').removeClass('d-none-loader')
        $(this.formData.firstElementChild).find('.search-vin__decoder-vin-submit').prop("disabled", true)
    }

    stopLoading() {
        $(this.formData.firstElementChild).find('.loader1212decoder').addClass('d-none-loader')
        $(this.formData.firstElementChild).find('.search-vin__decoder-vin-submit').prop("disabled", false)
    }

}

$(".hid-click").click(function (e) {
    $(this).toggleClass('menu-open').siblings(".accordion-hid-info-table-hidden").slideToggle("slow")
});

window.VinForm = VinForm;
window.CursorDots = CursorDots;
